import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { ApiResponse } from '@/api/handlers/responses';
import { UserQueryKeys } from './userQueryKeys';

export const useDeleteUserMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<ApiResponse<void>, Error, string>({
        mutationFn: (id) => apiClient.users.deleteUser(id),
        onSuccess: (result) => {
            if (result.success) {
                queryClient.invalidateQueries({ queryKey: UserQueryKeys.all });
            }
        },
    });
};
